module.exports = __webpack_public_path__ + "fonts/qtzaintextboldpc-bold.0fb44f2c.woff2";